module.exports = __webpack_public_path__ + "static/media/FullIntroENG.39b12956.vtt";